/**
 * @file 协议列表接口
 */
import $ from 'zepto'

export interface ListItem {
  templateCode: string
  name: string
  url: string
}
export interface List {
  data: ListItem[]
  errorCode: number
  errorMsg: string
  traceId: string
}

export const httpList = <T>(): Promise<T> => {
  return new Promise((resolve) =>
    $.post(
      '/api/noauth/contract/template',
      {
        stage: 'PLATFORM_AGREEMENT',
      },
      (data: T) => resolve(data)
    )
  )
}

export const httpContent = <T>(
  templateCode: string
): Promise<T> => {
  return new Promise((resolve) =>
    $.post(
      '/api/noauth/contract/preview',
      {
        templateCode,
      },
      (data: T) => resolve(data)
    )
  )
}
